import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";

/**
 * Converts a prop value (either a literal, like `4`, or a responsive value,
 * like `{ mobile: 2, desktop: 4}`) to a value that can be passed to
 * `classes(...)` to resolve to classnames.
 *
 * The conversion is based on the convention that `base-styles` tokens are
 * generally in the form `NAME-VALUE`, e.g. `margin-all-3`, where VALUE is
 * the prop value. For desktop values, `NAME-VALUE--wide` is used instead.
 *
 * For tokens that don't follow this pattern, like `flex-wrap` (which has the
 * tokens `flex-wrap` and `flex-wrap-nowrap`), you can provide a custom
 * `resolvePropValue` function.
 */
function resolveResponsivePropInternal(props, name) {
  var resolvePropValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (value) {
    return "".concat(name, "-").concat(value);
  };

  if (!props) {
    return [];
  }

  if (typeof props === 'string' || typeof props === 'number') {
    // Simple case - only need a single value
    return [resolvePropValue(props)];
  }

  if (_typeof(props) === 'object') {
    var mobile = props.mobile,
        desktop = props.desktop;
    return [mobile != null && resolvePropValue(mobile), desktop != null && "".concat(resolvePropValue(desktop), "--wide")].filter(function (x) {
      return !!x;
    });
  }

  throw new Error("Invalid responsive props: ".concat(JSON.stringify(props)));
}

function resolveResponsiveBaseStylesProp(props, name, resolvePropValue) {
  return resolveResponsivePropInternal(props, name, resolvePropValue);
}
/**
 * Resolves a responsive prop from a CSS Modules style object. As with
 * base-styles, we use the convention of a `--wide` suffix to indicate
 * classes that take affect on wide (desktop) displays.
 *
 * The return value can be passed to `classnames` to resolve the styles.
 */


function resolveResponsiveProp(props, name, styles) {
  var resolvedClassnames = resolveResponsivePropInternal(props, name);
  return resolvedClassnames.map(function (classname) {
    return styles[classname];
  });
}

export { resolveResponsiveProp, resolveResponsiveBaseStylesProp };